import { render, staticRenderFns } from "./DesignUpload.vue?vue&type=template&id=7a887774&scoped=true"
import script from "./DesignUpload.vue?vue&type=script&lang=ts"
export * from "./DesignUpload.vue?vue&type=script&lang=ts"
import style0 from "./DesignUpload.vue?vue&type=style&index=0&id=7a887774&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a887774",
  null
  
)

export default component.exports